import { render, staticRenderFns } from "./WsDemoExamsFilter.vue?vue&type=template&id=b3df565a"
import script from "./WsDemoExamsFilter.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsFilter.vue?vue&type=script&lang=js"
import style0 from "./WsDemoExamsFilter.vue?vue&type=style&index=0&id=b3df565a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports